import Alpine from 'alpinejs';
import keyDatesTimeline from './Libraries/Fund/timeline';

import './Libraries/bootstrap';

import './Libraries/Accordion/listener';
import './Libraries/Aos/listener';
import './Libraries/Attribution';
import './Libraries/Article/listener';
import './Libraries/BlockContent/listener';
import './Libraries/Lightbox/listener';
import './Libraries/MegaMenu/listener';
import './Libraries/ReadMore/listener';
import './Libraries/ScrollTo/listener';
import './Libraries/SimpleToggle';
import './Libraries/ShowMore';
import './Libraries/StickyNav';
import './Libraries/Swiper/listener';
import './Libraries/TippyPopUp';
import './Libraries/VideoEmbed';
import './Libraries/VideoModal/listener';
import './Libraries/VideoStream/listener';

Alpine.data('keyDatesTimeline', keyDatesTimeline);

window.Alpine = Alpine;

Alpine.start();
